<div class="flex-diagnostics-dialog" role="dialog" aria-labelledby="flex-diagnostics-title">
    <div
        class="popupHeader title non-printable"
        mat-dialog-title
        cdkDrag
        cdkDragHandle
        cdkDragRootElement=".cdk-overlay-pane"
        cdkDragBoundary=".cdk-overlay-container"
    >
        <span id="flex-diagnostics-title">{{ 'DIAGNOSTICS.FLEX_DIAGNOSTIC_SUPPORT' | translate }}</span>
    </div>
    <div mat-dialog-content class="content">
        <div
            class="tab-list non-printable"
            role="tablist"
            [attr.aria-label]="'DIAGNOSTICS.FLEX_DIAGNOSTIC_SUPPORT' | translate"
        >
            <button
                #tabButton
                mat-button
                type="button"
                class="tab-button"
                role="tab"
                *ngFor="let tab of tabs; index as i; trackBy: trackByLabelKey"
                [id]="'flex-diagnostics-tab-' + i"
                [attr.aria-controls]="'flex-diagnostics-panel-' + i"
                [attr.aria-selected]="selectedTabIndex === i"
                [attr.tabindex]="selectedTabIndex === i ? 0 : -1"
                [ngClass]="{ active: selectedTabIndex === i }"
                [cdkFocusInitial]="i === 0"
                (keydown)="handleTabKeydown($event, i)"
                (click)="selectTab(i)"
            >
                <mat-icon>{{ tab.icon }}</mat-icon>
                <span>{{ tab.labelKey | translate }}</span>
            </button>
        </div>
        <div class="tab-content">
            <section
                id="flex-diagnostics-panel-0"
                role="tabpanel"
                aria-labelledby="flex-diagnostics-tab-0"
                [hidden]="selectedTabIndex !== 0"
            >
                <app-flex-monitor-status [dialogData]="data" (closeRequested)="close()"></app-flex-monitor-status>
            </section>
            <section
                *ngFor="let tab of tabs.slice(1); index as i"
                [id]="'flex-diagnostics-panel-' + (i + 1)"
                role="tabpanel"
                [attr.aria-labelledby]="'flex-diagnostics-tab-' + (i + 1)"
                [hidden]="selectedTabIndex !== i + 1"
            >
                <div class="placeholder-toolbar non-printable">
                    <strong>{{ tab.labelKey | translate }}</strong>
                    <button mat-button type="button" (click)="close()">
                        <mat-icon>close</mat-icon>
                        {{ 'COMMON.CLOSE' | translate }}
                    </button>
                </div>
            </section>
        </div>
    </div>
</div>
